module.exports = __webpack_public_path__ + "img/panama-canal.52351a40.jpg";